module.exports = {
	init: function ($el, $) {
		//figure out root
		var moduleSearchPathsKey =
			(_.get($, 'page.resourceType') || '').split('/').slice(0, 2).join('.') + '.tagsRoot';
		var defaultSearchPathsKey = window.BL.config.defaultModule + '.tagsRoot';
		var root =
			$.widget.root ||
			_.get(window.BL.modules, moduleSearchPathsKey) ||
			_.get(window.BL.modules, defaultSearchPathsKey) ||
			'/etc/tags';
		root = root.replace(/([^:]+):(.*)/, '/etc/tags/$1/$2');

		const displayRoot = _.map(root.replace('/etc/tags/', '').split('/'), _.startCase).join(' / ');
		$el.find('.display-tag-root').html(displayRoot);

		var tagsQuery = `/content.custom-query.json?statement=SELECT * FROM [cq:Tag] WHERE [sling:resourceType] = 'cq/tagging/components/tag' AND ISDESCENDANTNODE('${root}') ORDER BY [jcr:title]&queryType=JCR-SQL2&property=jcr:title`;
		$.sling.request(tagsQuery, { leaveMangledNames: true }, function (err, data) {
			if (err) {
				console.log('Error getting tag data', err);
				$el.find('div').html('<p style="color:red;">Error retrieving tag data</p>');
				return;
			}
			var initialValue = $el.data('value') || [];

			var availableTags = data.reduce(
				(aggregate, tagResult) => {
					var tagId = pathToId(tagResult['jcr:path']);
					var tagIdPieces = tagId.split('/');

					var tagName = tagResult['jcr:title']; //tagIdToTitle(tagIdPieces.join('/'), `${tagNode} (${tagResult['jcr:title']})`);
					aggregate.lookup[tagId] = {
						tag: tagName,
						id: tagId,
						tooltip: tagId,
						depth: tagIdPieces.length,
					};

					aggregate.autocomplete[tagId] = {
						tag: `${tagName} `, //Add space at the end for autocomplete to work with exact match
						id: tagId,
						tooltip: tagId,
						depth: tagIdPieces.length,
					};
					return aggregate;
				},
				{ lookup: {}, autocomplete: {} }
			);

			//Lookup parent tag names to display full path relative to root
			_.each(availableTags.autocomplete, (entry, key) => {
				let tagParts = entry.id.split('/');
				tagParts.pop();
				while (
					tagParts.join('/').replace(/([^:]+):(.*)/, '/etc/tags/$1/$2') !== root &&
					tagParts.length > 0
				) {
					availableTags.autocomplete[key].tag =
						`${availableTags.lookup[tagParts.join('/')].tag} / ${availableTags.autocomplete[key].tag}`;
					tagParts.pop();
				}
			});
			//Reorder the tags
			const sortedTags = _.sortBy(availableTags.autocomplete, 'tag');
			availableTags.autocomplete = {};
			_.each(sortedTags, entry => {
				const include = $.widget.minDepth ? entry.depth >= $.widget.minDepth : true;
				if (include) {
					availableTags.autocomplete[entry.tag] = entry;
				}
			});

			initialValue = !_.isArray(initialValue) ? [initialValue] : initialValue;
			initialValue = _.map(initialValue, tagId => {
				return {
					tag: _.get(availableTags.lookup[tagId], 'tag', tagId + ' (Invalid Tag)'),
					id: tagId,
					tooltip: tagId,
				};
			});

			let chips = $el.find('.chips');
			chips.material_chip({
				data: initialValue,
				autocompleteData: availableTags.autocomplete,
				onlyAutocomplete: true,
			});
			if (!_.isEmpty(initialValue)) {
				$el.find('label').addClass('active');
			}

			const $input = $el.find('input');
			const toggleInput = function () {
				if ($el.find('.chip').length >= parseInt($.widget.limit)) {
					$input.attr('disabled', true);
				} else {
					$input.attr('disabled', false);
				}
			};

			chips.on('chip.add', () => {
				$el.find('label').addClass('active');
				if ($.widget.limit) {
					toggleInput();
				}
			});
			if ($.widget.limit) {
				toggleInput();
				chips.on('chip.delete', toggleInput);
			}
			const chipsInput = chips.find('input');
			const $autocomplete = $el.find('.autocomplete-content.dropdown-content');
			function toggleTagOptions() {
				let keyEvent = jQuery.Event('keyup');
				if ($autocomplete.children('li').length > 0) {
					keyEvent.which = 38;
				} else {
					keyEvent.which = 40;
				}
				chipsInput.trigger(keyEvent);
			}
			chips.dblclick(toggleTagOptions);
			$el.find('.open-tags').click(toggleTagOptions);
		});

		// $el.find(".tag-name").each(function(idx, item){
		// 	var $item = $(item);
		// 	var fullTag = $item.html().trim();
		// 	$item.data("value",fullTag);
		// var slashed = fullTag.split(":").pop();
		// var parts = slashed.split("/");
		// var fixed=[];
		// parts.forEach(function(val){
		// 	val=val.replace(/\-|\_/g, " ");
		// 	val=val.replace(/ [a-z]|^[a-z]/g, function(v){return v.toUpperCase();});
		// 	fixed.push(val);
		// });
		// fixed.push("<span style='color:black'>" + fixed.pop() + "</span>");
		// 	$item.html(fixed.join(" &nbsp;/&nbsp; "));
		// });
	},
	getValue: function ($el, name, $) {
		var vals = [];
		$el.find('.chips .chip').each(function (idx, item) {
			vals.push({ name: name, value: $.$(item).data('data').id });
		});
		vals.push({ name: name + '@Delete', value: 'true' });
		vals.push({ name: name + '@TypeHint', value: 'String[]' });
		return vals;
	},
	getPlainValue: function ($el, name, $) {
		return $el.data('value');
	},
};

////////////////////////
function pathToId(tagPath) {
	var tagIdPieces = tagPath.split('/').splice(3);
	return tagIdPieces.shift() + ':' + tagIdPieces.join('/');
}

////////////////////////
function tagIdToTitle(tagId, finalSegment) {
	var slashed = tagId.split(':').pop();
	var parts = slashed.split('/');
	var fixed = [];
	parts.forEach(function (val) {
		val = val.replace(/\-|\_/g, ' ');
		val = val.replace(/ [a-z]|^[a-z]/g, function (v) {
			return v.toUpperCase();
		});
		fixed.push(val);
	});
	fixed.push(
		'<span style="color:black">' + (finalSegment ? finalSegment : fixed.pop()) + '</span>'
	);
	return fixed.join(' &nbsp;/&nbsp; ');
}
